/**
 * Sign-in monitor: unknown-member error + failed sign-in alerts.
 *
 * Ghost Portal's React app runs in this window (it only renders into an
 * iframe), so wrapping window.fetch lets us observe its calls to
 * /members/api/send-magic-link/. When a sign-in is rejected because no member
 * exists for the email, we:
 *   1. show a persistent inline error in the Portal popup with a
 *      "Request to Join" link (opens the HubSpot join modal), and
 *   2. if a failure form is configured (theme setting
 *      hubspot_signin_failure_form_id), submit the email to that HubSpot form.
 *      HubSpot keeps the log and emails the admins set as submission
 *      notification recipients.
 *
 * Portal's own handling is untouched: we read a clone of the response.
 */
(function () {
  if (!window.fetch || window.__dwSigninMonitor) return;
  window.__dwSigninMonitor = true;

  var ENDPOINT = "/members/api/send-magic-link";
  var NO_MEMBER = /no member exists/i;
  var BANNER_ID = "dw-signin-error";

  var originalFetch = window.fetch;

  function requestUrl(input) {
    if (typeof input === "string") return input;
    if (input && input.url) return input.url;
    return String(input || "");
  }

  function parseBody(init) {
    if (!init || typeof init.body !== "string") return null;
    try {
      return JSON.parse(init.body);
    } catch (e) {
      return null;
    }
  }

  window.fetch = function (input, init) {
    var promise = originalFetch.apply(this, arguments);
    var url = requestUrl(input);
    if (url.indexOf(ENDPOINT) === -1) return promise;

    var body = parseBody(init);
    if (!body || body.emailType !== "signin" || !body.email) return promise;
    var email = String(body.email).trim();

    promise
      .then(function (res) {
        if (res.ok) {
          clearBanner();
          return;
        }
        if (res.status < 400 || res.status >= 500) return;
        return res
          .clone()
          .text()
          .then(function (text) {
            if (!NO_MEMBER.test(text)) return;
            showBanner(email);
            reportFailure(email);
          });
      })
      .catch(function () {});

    return promise;
  };

  /* Inline error inside the Portal popup
  /* ---------------------------------------------------------- */

  function portalDoc() {
    var root = document.getElementById("ghost-portal-root");
    if (!root) return null;
    var frames = root.querySelectorAll("iframe");
    for (var i = 0; i < frames.length; i++) {
      try {
        var doc = frames[i].contentDocument;
        if (
          doc &&
          doc.querySelector('input[type="email"], input[name="email"]')
        ) {
          return doc;
        }
      } catch (e) {}
    }
    return null;
  }

  function clearBanner() {
    var doc = portalDoc();
    var el = doc && doc.getElementById(BANNER_ID);
    if (el) el.remove();
    document.documentElement.classList.remove("dw-signin-failed");
  }

  function closePortal(doc) {
    // Portal binds its close handler to the <svg> icon; SVG elements have no
    // .click(), so dispatch the event instead.
    var close =
      doc.querySelector("svg.gh-portal-closeicon") ||
      doc.querySelector(".gh-portal-closeicon-container");
    if (close) {
      close.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    } else if (window.location.hash.indexOf("#/portal") === 0) {
      window.location.hash = "";
    }
  }

  function showBanner(email) {
    // Portal re-renders after the response settles; wait a frame or two.
    var attempts = 0;
    (function place() {
      var doc = portalDoc();
      if (!doc) {
        if (++attempts < 20) setTimeout(place, 50);
        return;
      }
      var input = doc.querySelector('input[type="email"], input[name="email"]');
      var old = doc.getElementById(BANNER_ID);
      if (old) old.remove();

      var banner = doc.createElement("div");
      banner.id = BANNER_ID;
      banner.className = "dw-signin-error";
      banner.setAttribute("role", "alert");

      var msg = doc.createElement("p");
      msg.appendChild(
        doc.createTextNode("We couldn't find a member account for "),
      );
      var strong = doc.createElement("strong");
      strong.textContent = email;
      msg.appendChild(strong);
      msg.appendChild(
        doc.createTextNode(
          ". Check the address for typos, or request to join the community.",
        ),
      );

      var link = doc.createElement("a");
      link.href = "https://georgian.io/community";
      link.className = "dw-signin-error-join";
      link.textContent = "Request to Join";
      link.addEventListener("click", function (e) {
        if (!window.dwJoinModal) return; // fall back to the href
        e.preventDefault();
        closePortal(doc);
        setTimeout(function () {
          window.dwJoinModal.open();
        }, 150);
      });

      banner.appendChild(msg);
      banner.appendChild(link);

      var form = input.closest("form") || input.parentNode;
      var anchor = input.closest("section, .gh-portal-input-section") || input;
      if (anchor.parentNode && form.contains(anchor)) {
        anchor.parentNode.insertBefore(banner, anchor.nextSibling);
      } else {
        form.appendChild(banner);
      }
      document.documentElement.classList.add("dw-signin-failed");

      input.addEventListener("input", clearBanner, { once: true });
    })();
  }

  /* Failure log + email alert via HubSpot form submission
  /* ---------------------------------------------------------- */

  function reportFailure(email) {
    var cfg = window.__dwHubspot || {};
    if (!cfg.portalId || !cfg.failureFormId) return;

    var url =
      "https://api.hsforms.com/submissions/v3/integration/submit/" +
      encodeURIComponent(cfg.portalId) +
      "/" +
      encodeURIComponent(cfg.failureFormId);

    originalFetch
      .call(window, url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          submittedAt: Date.now(),
          fields: [{ objectTypeId: "0-1", name: "email", value: email }],
          context: {
            pageUri: window.location.href,
            pageName: document.title,
          },
        }),
        keepalive: true,
      })
      .catch(function () {});
  }
})();
